module.exports = __webpack_public_path__ + "static/assets/eb60a8daa8f3c8e61c2814f6595cd95d.gif";